export const lotStateEnum = {
  New: 0,
  Used: 1,
};

export const lotTypesEnum = {
  Offer: 'Offer',
  LookingFor: 'Looking For',
};

export const QueryString = {
  categoryId: 'categoryId=',
  locationIds: 'locationIds=',
  productType: 'productType=',
  searchQuery: 'query=',
  lotType: 'lotType=',
};

export const notificationFrequencyTypes = [
  { label: 'Once a day', value: 'Daily' },
  { label: 'Once a week', value: 'Weekly' },
  { label: 'Once per two weeks', value: 'OncePerTwoWeeks' },
  { label: 'Once per month', value: 'OncePerMonth' },
  { label: 'Never', value: 'Never' },
];

export enum LotStatus {
  Published = 'Published',
  Deactivated = 'Deactivated',
}
